export const mutations = {
  addLaboursItem(state) {
    state.labour_item.push({
      truck_id: "",
      labour_description: "",
      labour_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    });
  },

  STORE_LABOURS(state, numberlesslabours) {
    state.numberlesslabours = numberlesslabours;
  },

  STORE_LABOUR_ITEMS(state, labour_items) {
    state.labour_items = labour_items;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/numberlesslabours/mutations.js